import SearchAndSortableTable from '../../../../../../components/table/SearchAndSortableTable';
import { useGetSchoolSelectorTable, useHandleSelectedDistrict } from './TeacherSchoolRosterSchoolSelectorHooks';
import './TeacherSchoolRosterSchoolSelector.scss';
import SearchDistrictAction from '../../../../components/actions/search-district/SearchDistrictAction';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  initSelectedSchoolIds: [],
  onDataChange: () => null,
  sortBySelectedIds: false,
  loading: false,
  disabledSchoolIds: [],
};

const TeacherSchoolRosterSchoolSelector = (p) => {
  const {
    initSelectedSchoolIds,
    onDataChange,
    disabledSchoolIds,
    sortBySelectedIds,
    loading,
  } = { ...defaultProps, ...filterUndefined(p) };
  const { selectedDistrictIds, onFilterDistrictChange } = useHandleSelectedDistrict();

  const {
    tableConfig,
    schoolTableData,
  } = useGetSchoolSelectorTable({
    initSelectedSchoolIds,
    disabledSchoolIds,
    onDataChange,
    sortBySelectedIds,
    selectedDistrictIds,
  });

  return (
    <div className='teacher-school-roster-school-selector'>
      <SearchAndSortableTable
        containerClassName='student-selector-table'
        config={tableConfig}
        tableData={schoolTableData}
        searchPlaceholder='SchoolName'
        preToolbarAction={[
          <SearchDistrictAction
            key='admin-school-roster-search-district'
            filterValue={selectedDistrictIds}
            onFilterChange={onFilterDistrictChange}
            isMultiple
          />,
        ]}
        initTableState={sortBySelectedIds ? {
          order: 'desc',
          orderBy: 'isSelected',
        } : {
          order: 'desc',
          orderBy: 'schoolName',
        }}
        searchField='schoolName'
        autoResetTableState={false}
        loading={loading}
      />
    </div>
  );
};

export default TeacherSchoolRosterSchoolSelector;
